import { ASSET_TYPES, ASSET_TYPE_TO_COORDINATES, AI_SUPPORTED_ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
import { OBJECT_TYPE_ID_TO_ASSET_TYPE } from '../constants/objectTypeIds';
export const isSupportedAssetType = assetType => Object.values(ASSET_TYPES).some(value => value === assetType);
export const safeGetAssetType = (assetSource, fallback) => assetSource && isSupportedAssetType(assetSource) ? assetSource : fallback;
export const createAssetCoordinates = (assetType, assetId) => ({
  source: assetType,
  id: Number(assetId),
  __typename: ASSET_TYPE_TO_COORDINATES[assetType]
});
export const safeCreateAssetCoordinates = (assetSource, assetId) => {
  const assetType = safeGetAssetType(assetSource);
  if (!assetType || !assetId) {
    return undefined;
  }
  const assetCoordinates = createAssetCoordinates(assetType, assetId);
  return assetCoordinates.__typename ? assetCoordinates : undefined;
};
export const getAssetTypeFromObjectTypeId = objectTypeId => OBJECT_TYPE_ID_TO_ASSET_TYPE[objectTypeId];
export const isAiSupportedAssetType = assetType => isSupportedAssetType(assetType) && AI_SUPPORTED_ASSET_TYPES.includes(assetType);